$(document).ready(function() {
  const $amountInput = $('#user_operation_amount');
  const $commissionHolder = $('#commission_calculation');
  const commissionFraction = parseFloat($('#new_user_operation').data('commissionFraction'));
  const $totalAmountHolder = $('#total-amount-confirmation');
  const $payinBtn = $('#payin');
  const $overLimitText = $('#overLimitText');

  $amountInput.on('keyup', function() {
    const amount = parseInt($amountInput.val());
    const commission = amount * commissionFraction;

    const truncatedCommission =  Math.trunc(commission * 100) / 100;

    if ((commission || commission === 0) && amount + truncatedCommission <= 2500) {
      $commissionHolder.text(`Frais: ${truncatedCommission} €`);
      $totalAmountHolder.text(`${amount + truncatedCommission} €`);
      $payinBtn.prop('disabled', false);
      $overLimitText.addClass('d-none');
    } else {
      $commissionHolder.text('');
      $payinBtn.prop('disabled', true);
      if (amount) {
        $overLimitText.removeClass('d-none');
      }
    };
  });
});
